import React, { Fragment } from 'react';
import { ArrowRightIcon } from 'lucide-react';
export function OnboardingSlide() {
  const steps = [{
    step: 1,
    label: 'Download & Open App',
    sublabel: 'Welcome screen',
    image: 'https://cdn.magicpatterns.com/uploads/oQcXbqX7kxkaNRdybCe5pY/Step2.png',
    highlight: false
  }, {
    step: 2,
    label: 'Login via UAE Pass',
    sublabel: 'UAE Pass login screen',
    image: 'https://cdn.magicpatterns.com/uploads/oXAfCFit7ABNSmts9arHLP/Step3.png',
    highlight: true
  }, {
    step: 3,
    label: 'Share Verified Documents',
    sublabel: 'UAE Pass approval',
    image: 'https://cdn.magicpatterns.com/uploads/t6jYefFeJ7b82e76rmYbuX/Step4.png',
    highlight: true
  }, {
    step: 4,
    label: 'Profile Activated',
    sublabel: 'Link Driver to Vehicle',
    image: 'https://cdn.magicpatterns.com/uploads/tWMrZ9zzzV71zqvHA2qhKu/Add_bike_Main_screen_1.png',
    highlight: false
  }];
  return <div className="flex flex-col w-screen h-screen overflow-hidden bg-white text-[#1a1a2e] px-8 py-4" data-id="element-302">
      {/* Top Header */}
      <div className="flex justify-between items-start shrink-0" data-id="element-303">
        <img src="https://cdn.magicpatterns.com/uploads/wGUVVF9ppu2J6VxJ2kpoN3/Pair2_Logo.png" alt="Pair2 Logo" className="h-8 w-auto object-contain" data-id="element-304" />
      </div>

      {/* Title — compact */}
      <div className="text-center shrink-0 mb-1" data-id="element-305">
        <span className="text-xs font-semibold text-[#2EBCB0] uppercase tracking-widest" data-id="element-306">
          How It Works
        </span>
        <h1 className="text-[1.25rem] font-bold text-[#1a1a2e] mt-0.5" data-id="element-307">
          Fully Digital Driver Onboarding
        </h1>
        <p className="text-[0.75rem] text-gray-500 mt-1 max-w-2xl mx-auto leading-snug" data-id="element-308">
          Companies invite drivers by adding phone numbers individually or via
          bulk upload. The system handles full digital onboarding automatically
          via UAE Pass.
        </p>
      </div>

      {/* Main Flow — 4 screenshots */}
      <div className="flex-grow flex items-center justify-center gap-3 px-2 w-full" data-id="element-309">
        {steps.map((step, idx) => <Fragment key={idx} data-id="element-310">
            <div className="flex flex-col items-center flex-1 min-w-0" data-id="element-311">
              {/* Step Number */}
              <div className="w-6 h-6 rounded-full flex items-center justify-center text-[0.65rem] font-bold mb-1.5 bg-[#2EBCB0] text-white" data-id="element-312">
                {step.step}
              </div>

              {/* Screenshot */}
              <div className="w-full rounded-xl overflow-hidden mb-1.5" data-id="element-313">
                <img src={step.image} alt={step.label} className="w-full h-auto object-contain" data-id="element-314" />
              </div>

              {/* Label */}
              <h3 className="font-bold text-[0.75rem] text-[#1a1a2e] text-center leading-tight" data-id="element-315">
                {step.label}
              </h3>
            </div>

            {/* Arrow between steps */}
            {idx < steps.length - 1 && <div className="shrink-0 flex items-center px-0.5 -mt-8" data-id="element-316">
                <ArrowRightIcon className="w-4 h-4 text-[#2EBCB0]/50" data-id="element-317" />
              </div>}
          </Fragment>)}
      </div>

      {/* Bottom Tagline */}
      <div className="text-center shrink-0" data-id="element-318">
        <p className="text-[0.75rem] italic text-gray-400" data-id="element-319">
          "A fully automated onboarding process powered by verified digital
          identity."
        </p>
      </div>
    </div>;
}